import TicketIcon from '../components/TicketIcon';
import InfoscreenConfig from '../config';
import TICKET_CALL_MODE from '../helpers/TicketCallMode';
import TICKET_ANIMATIONS from '../helpers/TicketAnimations';
import {WINDOW_TYPE_TRANSLATIONS} from '@/constants/WindowType';
import {generateAudioCallByTicket, asyncTimeout} from '@/helpers/utils';

export default {
  components: {
    TicketIcon
  },
  props: {
    ticket: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      WINDOW_TYPE_TRANSLATIONS,
      defaultFullscreenWindowNumberFontSize: 9.205,
      cachedFontSize: null,
      cachedFullscreenFontSize: null,
      isCalled: false
    };
  },
  watch: {
    isCalled: {
      handler(isCalled) {
        if (this.$store.infoscreenData.ticketCallAnimation !== TICKET_ANIMATIONS.FULLSCREEN) return;

        if (isCalled) {
          this.setFullscreenFontSize();
        } else {
          this.setDefaultFontSize();
        }
      },
      immediate: true
    }
  },
  methods: {
    callTicket({ticket, ticketCallMode}, options = {animation: true, audio: true}) {
      this.setTicketIsCalled(true);

      const ticketActions = [];

      if (options.animation) {
        const animationAction = asyncTimeout(InfoscreenConfig.CALL_TICKET_DURATION);
        ticketActions.push(animationAction);
      }

      if (options.audio) {
        const audioCallAction = this.getAudioCallAction({ticket, ticketCallMode});
        ticketActions.push(audioCallAction);
      }

      return Promise.all(ticketActions).finally(() => this.setTicketIsCalled(false));
    },
    setTicketIsCalled(value) {
      this.isCalled = value;
      this.$store.infoscreenData.ticketIsCalling = value;
    },
    getAudioCallAction({ticket, ticketCallMode}) {
      if (!this.$store.deviceStartData.is_sound_enabled) return Promise.resolve();

      const callTicketType = ticketCallMode === TICKET_CALL_MODE.FIRST
        ? this.$store.infoscreenData.clientCallType
        : this.$store.infoscreenData.clientRecallType;

      const { audioNotifier } = this.$store.infoscreenData;

      return generateAudioCallByTicket(audioNotifier, ticket, callTicketType);
    },
    setFullscreenFontSize() {
      if (this.cachedFullscreenFontSize) {
        this.windowNumberFontSize = this.cachedFullscreenFontSize;
      } else {
        this.windowNumberFontSize = this.defaultFullscreenWindowNumberFontSize;
        this.fitFontSize().then((fontSize) => {
          this.cachedFullscreenFontSize = fontSize;
        });
      }
    },
    setDefaultFontSize() {
      if (this.cachedFontSize) {
        this.windowNumberFontSize = this.cachedFontSize;
      } else {
        this.windowNumberFontSize = this.defaultWindowNumberFontSize;
        this.fitFontSize().then((fontSize) => (this.cachedFontSize = fontSize));
      }
    },
    fitFontSize() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          const ratio = this.getFitFontSizeRatio(this.$refs.windowNumber);
          this.windowNumberFontSize *= ratio;
          resolve(this.windowNumberFontSize);
        });
      });
    },
    getFitFontSizeRatio(element) {
      const fittenWidth = element.offsetWidth;
      const currentWidth = element.scrollWidth;
      return fittenWidth / currentWidth;
    }
  }
};
